import BigNumber from "bignumber.js"
import dayjs from "dayjs"
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import moment from "moment"
import { fmtNumber } from "@/util"

export function soptFmt(list) {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  return list.map((item) => {
    return {
      key:item.id,
      id: item.id,
      name: item.marketName,
      coin: item.marketName,
      time: dayjs(item.createdAt * 1000).tz("America/New_York").format("YYYY-MM-DD HH:mm:ss"),
      status: item.state,
      side: item.side,
      type: item.type,
      price: fmtNumber(item.tradePrice),
      count: fmtNumber(item.tradeNum),
      deal: fmtNumber(item.usdtNum)
    }
  })
}

export function contractFmt(list,tab) {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  return list.map(item => {
    var price = item.openPrice
    if(item.state == 0 && tab == 0){
      price = item.limitPrice
    }


    return {
      key: item.id,
      id: item.id,
      name: item.marketName,
      multiple: item.multiple,
      side: item.side,
      type: item.type,
      time: dayjs(item.createdAt * 1000).tz("America/New_York").format("YYYY-MM-DD HH:mm:ss"),
      openNum: tab == 0 ? item.num : item.openNum,
      // holdNum: fmtNumber(item.contract_hold_amount),
      warrant: fmtNumber(item.amount),
      fee: fmtNumber(item.fee),
      profit: fmtNumber(item.profit),
      status: item.state,
      // margin: fmtNumber(item.contract_margin),
      openPrice: fmtNumber(price),
      closeTime: dayjs(item.closeTime * 1000).tz("America/New_York").format("YYYY-MM-DD HH:mm:ss"),
      sl: fmtNumber(item.stopLoss), //止损
      tp: fmtNumber(item.takeProfit), // 止盈
      close: item.closeType,
      last: fmtNumber(item.closePrice),
      symbol: item.marketSymbol,
      mergeKey: item.mergeKey,
      orderNum: item.orderNum,
      icon: item.icon? process.env.VUE_APP_IMG + item.icon : ''
    }
  })
}

export function secondFmt(list) {
  // dayjs.extend(utc)
  // dayjs.extend(timezone)
  return list.map(item => {
    const now = moment().unix()
    // const now = dayjs().tz("Asia/Shanghai").unix()
    const end = BigNumber(item.contract_open_time).plus(item.contract_second_time).toNumber()
    return {
      key: item.contract_id,
      id: item.contract_id,
      name: item.market.market_symbol,
      multiple: item.contract_multiple,
      open: item.contract_open_price,
      second: item.contract_second_time,
      amount: item.contract_order_amount,
      profit: item.contract_profit,
      endTime: BigNumber(end).minus(now).multipliedBy(1000).toNumber(),
      time: item.contract_create_time,
      last: item.contract_second_close_price ? item.contract_second_close_price : item.contract_close_price,
      direction: item.contract_direction,
      status: item.contract_status
    }
  })
}